"use strict";

jQuery( function ($) {
    if ($(document).width() < 1200) {
        //Toggle function for sub-menus (mainly intended to toggle the shopcategories in the main menu)
        $(`.nav-container .nav-main > .nav-main-item, 
           .nav-container .nav-level-2 > .nav-level-2-item,
           .nav-container .nav-level-3 > .nav-level-3-item,
           .shop-category-menu .shop-category-menu-controls-container, 
           .shop-category-menu .nav-main > .nav-main-item,
           .shop-category-menu .nav-level-2 > .nav-level-2-item`).on('click', function(e) {
            e.stopPropagation();

            if((!$(this).hasClass('menu-item-has-children') && !$(this).is('.shop-category-menu .shop-category-menu-controls-container'))) {
                return
            }

            e.preventDefault();
            // Toggle the submenu
            $(this).addClass('is-open');

            if ($('.shop-category-menu-controls-container').hasClass('is-open')){
                $('.header-container').addClass('shop-cat-nav-open');
            } else {
                $('.header-container').removeClass('shop-cat-nav-open');
            }

            if($(this).is('.shop-category-menu .nav-main > .nav-main-item.menu-item-has-children')) {
                $('.shop-categories-nav-button-container-back-to').addClass('active-back-to');
            } else {
                $('.nav-user-button-container-back-to').addClass('active-back-to');
            }

            if($('.nav-level-2-item').hasClass('is-open')) {
                $('.nav-level-2').css( 'overflow', 'visible' );
            } else {
                $('.nav-level-2').css( 'overflow', 'auto' );
            }
        });

        $('.shop-categories-nav-button-container-close').on('click', function(e) {
            $('.shop-category-menu-controls-container').removeClass('is-open');
            $('.header-container').removeClass('shop-cat-nav-open');
        });

        // back-to-previous button
        $('#nav-user-button-container-back-to, .shop-categories-nav-button-container-back-to').on('click', function(e) {
            if($('.nav-level-2 > .nav-level-2-item.menu-item-has-children').hasClass('is-open')) {
                $('.nav-level-2 > .nav-level-2-item.menu-item-has-children').removeClass('is-open');
                $('.nav-level-2').css( 'overflow', 'auto' );
            }else if ($('.nav-main > .nav-main-item.menu-item-has-children').hasClass('is-open')) {
                $('.nav-main > .nav-main-item.menu-item-has-children').removeClass('is-open');
                $('.nav-user-button-container-back-to, .shop-categories-nav-button-container-back-to').removeClass('active-back-to');
            }
        });

        // Shop footer menu
        $(`footer .nav-main > .nav-main-item, 
           footer .nav-level-2 > .nav-level-2-item,
           .shop-footer-nav .nav-main > .nav-main-item,
           .shop-footer-nav .nav-level-2 > .nav-level-2-item`).on('click', function(e) {
            e.stopPropagation();

            if(!$(this).hasClass('menu-item-has-children')) {
                return
            };

            e.preventDefault();

            // Toggle the submenu
            $(this).find('.nav-level-2, .nav-level-3').toggle(200);
            $(this).toggleClass('is-open');
        });
    } else {
        $('.menu-dummy-link > a').on('click', function(e){
            e.preventDefault();
            return
        });
    }


    // toggle the menu with the icon in the header
    $(document).on( 'click', '[data-toggle-menu]', function (e) {
        e.preventDefault();

        var menu_target = $(this).data('target-toggle'),
            mobile_menu = $(menu_target);

        mobile_menu.toggleClass('is-active');
        if ($(this).data('toggle-main-menu') == true) {
            $('#nav-main').toggleClass('is-open');
            if ($('#nav-main').hasClass('is-open')) {
                $('[data-toggle-menu-icon-menu]').addClass('d-none');
                $('[data-toggle-menu-icon-close]').removeClass('d-none');
            } else {
                $('[data-toggle-menu-icon-close]').addClass('d-none');
                $('[data-toggle-menu-icon-menu]').removeClass('d-none');
                $('.nav-main-item.menu-item-has-children').removeClass('is-open');
                $('.nav-level-2-item.menu-item-has-children').removeClass('is-open');
                $('.nav-user-button-container-back-to').removeClass('active-back-to');
            }
        }
    });


    // toggle the search form in the header
    $(document).on('click', '[data-toggle-search], .search-focus-overlay', function (e) {
        e.preventDefault();

        var search_target = $(this).data('target-toggle'),
            search_form = $(search_target);

        search_form.toggleClass('is-active');
        search_form.find('.header-search-input').focus();
    });
});